<template>

  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{ errorMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{ successMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ _.startCase(currentProfile) }}
          </h3>
        </div>
        <div class="col-md-9 text-right">
          <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div class="dropdown-item" v-if="accessRights.includes('T')"
                @click.prevent="showActionDrawer('print_list')">
                <i class="fa fa-print"></i>
                <span>Print</span>
              </div>
              <div v-if="serverType == 'ho' && accessRights.includes('I') && currentProfile != 'payment_types'" class="dropdown-item"
                @click.prevent="showActionDrawer('import_list')">
                <i class="fa fa-upload"></i>
                <span>Import</span>
              </div>
              <div v-if="accessRights.includes('E')" class="dropdown-item"
                @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                <i class="fa fa-list-ul"></i>
                <span>Customize List</span>
              </div>
            </template>
          </base-dropdown>

          <div v-if="serverType == 'ho'">
            <!-- {{this.checkedItems.length}}
            {{this.itemStatus}}
            {{this.$parent.filterStatus}}
            {{this.accessRights}} -->
            <div v-if="checkedItems.length == 0">
              <base-button v-if="(currentProfile != 'payment_types') && accessRights.includes('A')"
                class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0)">+ Add
                {{ _.startCase(_.singularize(currentProfile)) }}</base-button>
            </div>
            <div
              v-else-if="checkedItems.length == 1 && accessRights.includes('W') && (this.$parent.filterStatus == '' || this.$parent.filterStatus == '0')">
              <base-button v-if="this.itemStatus == 'I'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'A')">Activate</base-button>
              <base-button v-if="this.itemStatus == 'A'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'I')">Deactivate</base-button>
              <div class="ml-1"></div>
            </div>

            <div v-else-if="checkedItems.length > 0 && accessRights.includes('W')">
              <base-button v-if="this.$parent.filterStatus != 'A'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'A')">Activate</base-button>
              <base-button v-if="this.$parent.filterStatus != 'I'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'I')">Deactivate</base-button>
              <div class="ml-1"></div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'customize_list'">
        <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
        <small>Check the fields that you want to see on the list. Drag the fields to
          specify position.</small>
        <br /><br />

        <div class="list-group list-group-item">
          <div class="row">
            <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
            <div class="col-md-6">
              <a-checkbox class="float-right" @change="onCheckAllField" :checked="
                this.checkedFields.length == this.availableFields.length
              " />
            </div>
          </div>
        </div>

        <draggable :key="draggableKey" :list="availableFields" class="list-group" @start="dragging = true"
          @end="dragging = false">
          <div class="list-group-item draggable"
            :style="index == availableFields.length - 1 ? 'margin-bottom: 50px;' : ''"
            v-for="(element, index) in availableFields" :key="element">
            <div class="row">
              <!-- This _.startCase() will convert any casing into Start Case -->
              <div class="col-md-6">
                {{ _.startCase(element) }}
              </div>
              <div class="col-md-6">
                <a-checkbox class="float-right" @change="onCheckField(element)"
                  :checked="checkedFields.includes(element)" />
              </div>
            </div>
          </div>
        </draggable>

        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
          <button class="btn btn-primary float-right" @click.prevent="updateTableList">
            Update List
          </button>
        </div>
      </div>

      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6>
        <base-alert v-if="errors.length" type="danger">
          <b>You have the following error(s):</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </base-alert>
        <div>
          <a-radio-group v-model="exportSelection">
            <a-radio :style="radioStyle" :value="0">Export All</a-radio>
            <a-radio :style="radioStyle" :value="1">Export Current Page</a-radio>
            <a-radio :style="radioStyle" :value="2">Export Selected</a-radio>
            <a-radio :style="radioStyle" :value="3">Export Filtered</a-radio>
          </a-radio-group>
        </div>
        <div
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">Export</button>
        </div>
      </div>

      <div v-if="profileAction == 'print_list'">
        <h6 class="heading-small text-muted mb-4">Print Options</h6>
      </div>

      <div v-if="profileAction == 'import_list'">
        <import-profile @closeDrawer="closeDrawer"></import-profile>
      </div>
    </a-drawer>

    <a-drawer title="" :width="viewLicense? 750: 480" placement="right" @close="onClose" :visible="visible">
      <div>
        <device-form v-if="currentProfile == 'devices' && !viewLicense" v-on:refreshPage="refreshPage"
          v-on:displayMessage="displayMessage" :key="componentKey" :viewMode="viewMode" :locationOptions="locationOptions"></device-form>
        <bagger-form v-if="currentProfile == 'baggers'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></bagger-form>
        <bank-card-form v-if="currentProfile == 'bank_cards'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></bank-card-form>
        <bank-card-term-form v-if="currentProfile == 'bank_card_terms'" @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></bank-card-term-form>
        <bank-form v-if="currentProfile == 'banks'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></bank-form>
        <salesman-form v-if="currentProfile == 'salesmen'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></salesman-form>
        <reason-form v-if="currentProfile == 'reasons'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></reason-form>
        <reason-type-form v-if="currentProfile == 'reason_types'" @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></reason-type-form>
        <store-event-form v-if="currentProfile == 'store_events'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></store-event-form>
        <store-event-type-form v-if="currentProfile == 'store_event_types'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></store-event-type-form>
        <payment-type-form v-if="currentProfile == 'payment_types'" @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></payment-type-form>
        <div v-if="viewLicense">
          <br>
          <a-list bordered>
            <a-list-item v-for="license in deviceLicenses" :key="license.id">
                <a-list-item-meta :description="license.license_key || 'No License Key'">
                    <template #title>
                        <a>{{ license.site_name }}</a>
                    </template>
                    </a-list-item-meta>
                    <div>Status: {{ license.license_status }} <br>
                      expires: {{ moment(license.license_expiration_date).format("MM/DD/YYYY") }}
                    </div>
            </a-list-item>
        </a-list>
        </div>
      </div>
    </a-drawer>

    <div class="table-responsive">
      <a-spin :spinning="loading">
        <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
          :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
          no-data-template="Empty" @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log"
          @vuetable:load-error="onLoadError" @vuetable:pagination-data="onPaginationData">

          <template slot="actions" slot-scope="props">
            <center>
              <div v-if="serverType == 'ho'" class="table-button-container">
                <button id="view-license" v-if="currentProfile == 'devices' && accessRights.includes('V') && props.rowData.device_type_id == 2" class="btn btn-info btn-sm"
                  @click.prevent="showDrawer(props.rowData.id)">View Licenses</button>
                <button id="view" v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                  @click.prevent="showDrawer(props.rowData.id)">View</button>
                <!-- <button class="btn btn-success btn-sm" @click.prevent="showDrawer(props.rowData.id)">View</button>&nbsp;&nbsp; -->
                <button v-if="(accessRights.includes('W') && props.rowData.is_system == false && currentProfile == 'store_events') || (accessRights.includes('W') && currentProfile != 'store_events')" class="btn btn-warning btn-sm" @click.prevent="showDrawer(props.rowData.id)">Edit</button>
                <!-- <button class="btn btn-danger btn-sm" v-if="(currentProfile != 'payment_types')" @click.prevent="deleteRow(props.rowData.id)">Delete</button>&nbsp;&nbsp; -->
                <a-popconfirm v-if="(accessRights.includes('D') && currentProfile != 'payment_types' && currentProfile != 'store_events') || (accessRights.includes('D') && props.rowData.is_system == false && currentProfile == 'store_events')"
                  title="You are about to delete this record?" @confirm="deleteRow(props.rowData.id)" okText="Delete"
                  cancelText="Cancel">
                  <a class="btn btn-danger btn-sm text-white">Delete</a>
                </a-popconfirm>
              </div>
              <div v-else class="table-button-container">
                <button v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                  @click.prevent="showDrawer(props.rowData.id)">View</button>&nbsp;&nbsp;
              </div>
            </center>
          </template>

        </vuetable>
      </a-spin>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent'  : ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import {
  mapState,
  mapActions
} from 'vuex'
import BaggerForm from '../POS Profiles/BaggerForm.vue';
import BankForm from '../POS Profiles/BankForm.vue';
import BankCardForm from '../POS Profiles/BankCardForm.vue';
import BankCardTermForm from '../POS Profiles/BankCardTermForm.vue';
import SalesmanForm from '../POS Profiles/SalesmanForm.vue';
import ReasonForm from '../POS Profiles/ReasonForm.vue';
import ReasonTypeForm from '../POS Profiles/ReasonTypeForm.vue';
import PaymentTypeForm from '../POS Profiles/PaymentTypeForm.vue';
import DeviceForm from '../POS Profiles/DeviceForm.vue';
import StoreEventForm from '../POS Profiles/StoreEventForm.vue';
import StoreEventTypeForm from '../POS Profiles/StoreEventTypeForm.vue';

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest.js';
import draggable from "vuedraggable";

import { formatStatus } from "../../utilities.js"

import ImportProfile from '../ImportProfile';
var component_x;

export default {
  name: 'profiles-table',
  props: {
    type: {
      type: String
    },
    title: String
  },
  components: {
    Vuetable,
    VuetablePagination,
    BaggerForm,
    BankForm,
    BankCardForm,
    BankCardTermForm,
    ReasonForm,
    ReasonTypeForm,
    SalesmanForm,
    PaymentTypeForm,
    StoreEventForm,
    StoreEventTypeForm,
    ImportProfile,
    DeviceForm,
    draggable,
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters', 'serverType'])
  },
  data() {
    return {
      loading: false,
      locationOptions: [],
      viewMode: false,
      itemStatus: '',
      accessRights: [],
      errors: [],
      filterStatus: "",
      exportSelection: 0,
      profileAction: "",
      checkedFields: [],
      checkedItems: [],
      availableFields: [],
      errorMessage: null,
      successMessage: null,
      componentKey: 0,
      drawerVisible: false,
      visible: false,
      apiURL: "",
      fields: [],
      sortOrder: [{
        field: "name",
        direction: "asc"
      }],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        }
      },
      css: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      draggableKey: 0,
      deviceLicenses: [],
      viewLicense: false
    }
  },
  watch: {
    currentApiURL: function () {
      this.$refs.vuetable.resetData()
      this.apiURL = this.currentApiURL
    },
    parameters: function () {
      this.apiURL = this.currentApiURL
      this.apiURL = this.apiURL + this.parameters
      this.$refs.vuetable.selectedTo = []
      this.checkedItems = []
    },
    currentProfile: function () {
      this.initializeTable()
    }
  },
  methods: {
    moment,
    ...mapActions(['updateProfileId']),
    closeDrawer() {
      this.onClose()
    },
    refreshPage() {
      this.onClose()
      this.$refs.vuetable.refresh()
      this.successMessage = "Successful Operation"
      this.errorMessage = null
    },
    showDrawer(id) {
      if (event.target.id == "view") {
        this.viewMode = true
      }else if (event.target.id == "view-license") {
        this.viewLicense = true
        this.getDeviceLicenses(id)
      } else {
        this.viewMode = false
      }
      this.componentKey++
      this.updateProfileId(id)
      this.visible = true
    },
    async getDeviceLicenses(id) {
      var device_data = await HTTPRequest.getRequest(this.endPoint + 'devices/get_device_licenses?id=' + id, null)
      if(device_data != undefined){
        this.deviceLicenses = device_data
      }else{
        this.deviceLicenses = []
      }
    },
    async showActionDrawer(action) {
      if (action == "customize_list") {
        var response = await HTTPRequest.getRequest(
          this.endPoint + this.currentProfile + "/get_viewable_fields",
          null
        );
        
        let unsortedFields = response["fields"];
        let sortedFields = this.checkedFields.slice();

        unsortedFields.forEach(fieldName => {
          if (!this.checkedFields.includes(fieldName))
            sortedFields.push(fieldName)
        });

        this.availableFields = sortedFields;

      }
      this.profileAction = action;
      this.drawerVisible = true;
    },
    onClose() {
      this.errors = [];
      this.drawerVisible = false
      this.visible = false
      this.viewLicense = false
      this.componentKey++
    },
    log(checked, value) {
      this.checkedItems = this.$refs.vuetable.selectedTo
      if (this.checkedItems.length == 1) {
        this.itemStatus = value.status
        // console.log(this.itemStatus)
      } else {
        this.itemStatus = ''
      }
    },
    onCheckField(fieldName) {
      if (this.checkedFields.includes(fieldName)) {
        var indexValue = this.checkedFields.indexOf(fieldName);
        if (indexValue > -1) {
          this.checkedFields.splice(indexValue, 1);
        }
      } else {
        this.checkedFields.push(fieldName);
      }
    },
    onCheckAllField() {
      if (this.checkedFields.length == this.availableFields.length) {
        this.checkedFields = []
        this.fields = ['__checkbox', '__slot:actions']
      } else {
        this.checkedFields = this.availableFields.slice()
        this.fields = ['__checkbox']
        this.fields = this.fields.concat(this.checkedFields)
        this.fields.push("__slot:actions")
      }
    },
    reinitializeFields() {
      this.$nextTick(() => {
        this.$refs.vuetable.normalizeFields();
      });
    },
    async massupdate(field_name, value) {
      var field_update = {}
      field_update[field_name] = value
      var payload = {
        ids: this.checkedItems,
        field_update: field_update
      }
      var response = await HTTPRequest.postRequest(this.endPoint + this.currentProfile + "/mass_update", null,
        payload)
      if (response["message"] == "Ok") {
        this.successMessage = "Update successful!"
        this.$refs.vuetable.refresh()
        this.checkedItems = []
        this.$refs.vuetable.selectedTo = []
      } else {
        this.successMessage = "Update failed!"
      }
    },
    async onPaginationData(paginationData) {
      // await axios({
      //     method: 'PUT',
      //     url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
      //     headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
      // })
      this.$refs.pagination.setPaginationData(paginationData);
    },
    async onLoadError(error) {
      // request for new token or reauthenticate
      if (error.response.status == 401) {
        var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
        if (auth_response["status"] == "Ok") {
          this.$router.go();
        } else {
          alert("Cannot get access token. Please login again.")
          this.$router.push("/")
        }
      } else {
        if (error.response.data.error == "Session expired") {
          alert("Session is already expired. Please login again.")
          document.getElementById("logoutButton").click()
        } else if(error.response.data.error == "Invalid IP for Access Token"){
          alert("Invalid Access Token. Please login again.")
          document.getElementById("logoutButton").click()
        }
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    deleteRow(id) {
      axios({
        method: 'delete',
        url: this.endPoint + this.currentProfile + '/' + id,
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        },
      })
        .then(function () {
          component_x.successMessage = "Successfully deleted record"
          component_x.$refs.vuetable.refresh()
        })
        .catch(function () {
          alert("Invalid Credentials")
        });
    },
    download() { // Must update other Profile Tables download function to be aligned
      var payload = {}
      var additional_parameters = ""
      var baseUrl = this.currentApiURL + "/download?file_type=csv"
      if (this.exportSelection == "0") {
        // All
        payload["type"] = "all"
      } else if (this.exportSelection == "1") {
        // Current Page
        var ids = this.$refs.vuetable.tableData.map(({ id }) => id)
        payload["type"] = "current_page";
        if (ids == 0) {
          this.errors.push('No Record(s)');
          return;
        } else {
          payload["ids"] = ids
        }

      } else if (this.exportSelection == "2") {
        // Selected
        payload["type"] = "selected"
        if (this.checkedItems == 0) {
          this.errors.push('No Selected Record(s)');
          return;
        } else {
          payload["ids"] = this.checkedItems
        }
      } else {
        // Filtered
        payload["type"] = "filtered"
        additional_parameters = this.parameters
      }

      var exportFields = this.fields
      var cbIndex = this.fields.indexOf("__checkbox");
      if (cbIndex > -1) exportFields.splice(cbIndex, 1)
      var actionIndex = this.fields.indexOf("__slot:actions");
      if (actionIndex > -1) exportFields.splice(actionIndex, 1)

      payload["fields"] = exportFields
      additional_parameters = additional_parameters.replace('?', '&');

      axios({
        url: baseUrl + additional_parameters,
        method: 'POST',
        responseType: 'blob', // important
        headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.csv');
        document.body.appendChild(link);
        link.click();
        this.onClose();
        this.filterStatus = null
        this.successMessage = "Download successful"
      });
    },
    displayMessage(message) {
      if (message["error"] != undefined) {
        this.onClose()
        this.errorMessage = message["error"]
        this.successMessage = null
      }
    },
    removeMessage(type) {
      if (type == 'error')
        this.errorMessage = null
      else
        this.successMessage = null
    },
    updateTableList() {
      var reference_array = this.availableFields;
      var array = this.checkedFields;
      if (array.length) {
        array.sort(function (a, b) {
          return reference_array.indexOf(a) - reference_array.indexOf(b);
        });
        this.checkedFields = array;
      } else {
        this.checkedFields = ["code", "name", "status"];
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.'
        })
      }

      let localStoreName = this.currentProfile + "POSProfileCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields));

      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        } else return column
      })
      this.fields.push("__slot:actions");
      this.fields.unshift("__checkbox")

      this.reinitializeFields();
      this.onClose();
    }
  },
  beforeMount: async function () {
    const posProfileCustomList = localStorage.getItem(this.currentProfile + "POSProfileCheckedField")
    if (posProfileCustomList != undefined && posProfileCustomList != null && posProfileCustomList != "[]") {
      this.checkedFields = JSON.parse(posProfileCustomList)
      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        } else return column
      })
      this.fields.push("__slot:actions")
      this.fields.unshift("__checkbox")
      this.initLoad++
    } else {
      this.checkedFields = ["name"];
      this.fields = ["__checkbox", "id", "name", "__slot:actions"];
      localStorage.removeItem(this.currentProfile + "POSProfileCheckedFields")
    }
  },
  mounted: async function () {
    // if(this.serveType == 'ho'){
    //   this.fields =  ['__checkbox', "id", "name", '__slot:actions']
    //   this.$refs.vuetable.normalizeFields()
    // }else{
    //   this.fields =  ["id", "name", '__slot:actions']
    //   this.$refs.vuetable.normalizeFields()
    // }
    this.loading = true
    component_x = this;
    this.accessRights = this.$attrs.accessRights
    this.apiURL = this.currentApiURL

    if (this.currentProfile == "devices") {
      this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view?full=1', null)
    }
    this.loading = false

  }
}
</script>

<style>
</style>
